/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import ReactGA from 'react-ga';
ReactGA.initialize(process.env.GOOGLE_ANALYTICS_CODE);

exports.onRouteUpdate = (state, page, pages) => {
  setTimeout(() => {
    ReactGA.set({ anonymizeIp: true });
    ReactGA.pageview(state.location.pathname);
  })
};

const mpTokens = {
  development: '53f3639f564804dcb710fd18511d1c0b',
  production: 'bf30a47e42a01fa74c35175b455bc720'
}

const isDevelopment = /\/\/[localhost|staging]/.test(window.location.href)
const mpToken = isDevelopment ? mpTokens.development : mpTokens.production
window.mixpanel.init(mpToken)



// WEBPACK FOOTER //
// ./gatsby-browser.js